// デフォルト固定値(コントロール部)
export const DEFAULT_KUBUN = 'all'; // すべて
export const DEFAULT_TYPE = 0; // すべて (画面表示前追加)
export const DEFAULT_MAKER = 0; // すべて (画面表示前追加)
export const DEFAULT_DAY = 0; // 平日休日OFF
export const DEFAULT_DISP_TYPE = 0; // タイプOFF
export const DEFAULT_SHUBETSU = 1; // すべて
export const DEFAULT_PS = 0; // パチンコ
export const DEFAULT_PACHI_RATE = 1; // ４円
export const DEFAULT_SLOT_RATE = 3; // 20円
export const DEFAULT_HIKAN = 1; // 日間データON
export const DEFAULT_OFFSET = 1; // データ取得開始位置 1
export const DEFAULT_GOUKI = ''; // 号機
export const DEFAULT_SMARTYUGIKI = ''; // スマート遊技機
export const DEFAULT_YUGI_TYPE = ''; // 遊技タイプ
export const DEFAULT_DISPLAY_FORMAT = 'dow'; // 表示形式(曜日指定)
export const DEFAULT_TERM_FROM = 1; // 期間From
export const DEFAULT_TERM_TO = 14; // 期間To
export const ENABLE_SELECT_TERM_RANGE = 13; // 選択可能期間範囲(FROM週を含めた14週)
export const DEFAULT_MAX_TERM = 52; // 期間（最大指定可能週）
export const GRAPH_AXIS_WEEK_LENGTH = 2; // グラフX軸の表示期間数


export const DEFAULT_CALENDAR_VIEW_MODE = 'day'; // NEWカレンダーの表示モード
export const DEFAULT_KIKAN_UNIT = 'days'; // 期間データの単位
export const DEFAULT_KIKAN_UNIT_ALL = 'all'; // 期間データの単位

export const PS_PACHINKO = 0;
export const PS_SLOT = 1;

export const CHECK_API_CALL_DELAY = 100; // setInterval() が checkAPICallを呼び出す前に待つべき時間です。ミリ秒(1/1000 秒)単位で指定します 。
export const DEFAULT_DISPLAYALL = 'すべて'; // タイプ、ブランドが'0'の場合、CSV出力で'すべて'を表示する。

export const DEFAULT_GRAPH_DROPDOWN_OPTION_K012 = 'out';  // 推移グラフ：連動するプルダウンのデフォルト選択項目

export const DEFAULT_DISPLAY_GRAPH_FORMAT_K015 = 'K011'; // 推移グラフ：グラフ連動項目（期間別／導入後推移）
export const DEFAULT_DISPLAY_ITEM_K015 = 'out'; // 推移グラフ：第1軸項目のデフォルト選択項目
export const DEFAULT_BUNKIWARI_K015 = 'bunkiwari_11'; // スタート／設定分布：連動するプルダウンのデフォルト選択項目

export const GRAPH_X_DAY_OF_WEEK = ['月曜', '火曜', '水曜', '木曜', '金曜', '土曜', '日曜']; // グラフグリッド: 日間x軸

export const GRAPH_TYPE_DAILY = '0';
export const GRAPH_TYPE_WEEKLY = '1';
export const GRAPH_TYPE_MONTHLY = '2';

export const WEEK_START_DAY_FLG = 1; // カレンダーが何曜始まりか指定するフラグ(0:日曜, 1:月曜)
